<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center class="rm-list-container pa-6">
      <v-flex xs12>
        <!-- ══ FILTERS CONTAINER ══ -->
        <div class="filter-card mb-6">
          <v-row align="center" class="ma-0">
            <v-col cols="12" sm="3" md="2" class="py-2 px-3">
              <span class="filter-label">District</span>
              <v-select
                outlined
                hide-details
                placeholder="All Districts"
                dense
                :items="districts"
                v-model="keyword"
                color="#14532D"
                class="custom-select"
              />
            </v-col>
            
            <v-col cols="12" sm="3" md="2" class="py-2 px-3">
              <span class="filter-label">Resource Code</span>
              <v-text-field
                outlined
                hide-details
                placeholder="Search Code"
                dense
                v-model="resourceCode"
                clearable
                color="#14532D"
                class="custom-input"
              />
            </v-col>

            <v-col cols="12" sm="3" md="3" class="py-2 px-3">
              <span class="filter-label">Name</span>
              <v-text-field
                outlined
                hide-details
                placeholder="Search Name"
                dense
                v-model="Name"
                clearable
                color="#14532D"
                class="custom-input"
              />
            </v-col>

            <v-col cols="12" sm="3" md="3" class="py-2 px-3">
              <span class="filter-label">Phone</span>
              <v-text-field
                outlined
                hide-details
                placeholder="Search Phone"
                dense
                v-model="Phone"
                clearable
                color="#14532D"
                class="custom-input"
              />
            </v-col>

            <v-col cols="12" sm="12" md="2" class="py-2 px-3 d-flex align-end justify-md-end" v-if="userlist && userlist.length > 0">
              <v-btn
                color="#10B981"
                class="export-btn w-full mt-5"
                target="_blank"
                @click="getExcel()"
                block
                depressed
              >
                <v-icon left size="16">mdi-microsoft-excel</v-icon>
                Export
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- ══ BULK ACTIONS ══ -->
        <v-layout wrap justify-end mb-3 pr-2 v-if="selectedItems.length > 0">
          <v-btn
            color="#FF1313"
            class="export-btn mr-3"
            dark
            @click="bulkBanDialog = true"
            depressed
          >
            <v-icon left size="16">mdi-cancel</v-icon>
            Bulk Ban ({{ selectedItems.length }})
          </v-btn>
          <v-btn
            color="#D97706"
            class="export-btn"
            dark
            @click="bulkSuspendDialog = true"
            depressed
          >
            <v-icon left size="16">mdi-account-off</v-icon>
            Bulk Suspend ({{ selectedItems.length }})
          </v-btn>
        </v-layout>

        <!-- ══ TABLE CONTAINER ══ -->
        <v-layout wrap justify-start v-if="userlist && userlist.length > 0">
          <v-flex xs12>
            <v-card class="custom-table-card elevation-0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 50px;">
                        <v-checkbox
                          v-model="selectAll"
                          color="#14532D"
                          hide-details
                          class="ma-0 pa-0"
                          @change="toggleSelectAll"
                        ></v-checkbox>
                      </th>
                      <th class="text-left" style="width: 60px;"></th>
                      <th class="text-left">Rescuer Code</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">District</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in userlist"
                      :key="index"
                      class="clickable-row"
                      @click="openviewdetails(item)"
                    >
                      <td @click.stop class="text-center">
                        <v-checkbox
                          v-model="selectedItems"
                          :value="item._id"
                          color="#14532D"
                          hide-details
                          class="ma-0 pa-0"
                        ></v-checkbox>
                      </td>
                      <!-- Badge Icon -->
                      <td @click.stop>
                        <v-avatar size="32" v-if="item && item.level && item.level.badgeIcon" class="elevation-1">
                          <img :src="mediaURL + item.level.badgeIcon" alt="Badge" />
                        </v-avatar>
                        <v-avatar size="32" color="rgba(20,83,45,0.06)" v-else>
                          <v-icon size="16" color="#14532D">mdi-account</v-icon>
                        </v-avatar>
                      </td>

                      <td class="font-weight-medium">
                        <span v-if="item && item.rescuerCode">{{ item.rescuerCode }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td class="font-weight-bold" style="color: #1E293B;">
                        <span v-if="item && item.user && item.user.name">{{ item.user.name }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <span v-if="item && item.user && item.user.phone">{{ item.user.phone }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <span v-if="item && item.user && item.user.email">{{ item.user.email }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <v-chip small color="rgba(20,83,45,0.08)" text-color="#14532D" class="font-weight-medium">
                          {{ (item && item.district) ? item.district : '-' }}
                        </v-chip>
                      </td>
                      <td class="text-center" @click.stop>
                        <div class="d-flex align-center justify-center action-group">
                          <!-- Edit Details -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--edit"
                                v-bind="attrs"
                                v-on="on"
                                @click="openeditdetails(item)"
                              >
                                <v-icon size="16">mdi-pencil</v-icon>
                              </button>
                            </template>
                            <span>Edit Rescuer</span>
                          </v-tooltip>

                          <!-- Suspend Rescuer -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--suspend"
                                v-bind="attrs"
                                v-on="on"
                                @click="openSuspendDialog(item)"
                              >
                                <v-icon size="16">mdi-account-off</v-icon>
                              </button>
                            </template>
                            <span>Suspend</span>
                          </v-tooltip>

                          <!-- Ban Rescuer -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--ban"
                                v-bind="attrs"
                                v-on="on"
                                @click="banDialog(item)"
                              >
                                <v-icon size="16">mdi-cancel</v-icon>
                              </button>
                            </template>
                            <span>Ban</span>
                          </v-tooltip>

                          <!-- Delete Rescuer -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--delete"
                                v-bind="attrs"
                                v-on="on"
                                @click="rejectDialog(item.user._id)"
                              >
                                <v-icon size="16">mdi-delete</v-icon>
                              </button>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pb-4 v-if="userlist && userlist.length > 0">
        <v-layout wrap justify-center class="mt-6">
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              :total-visible="7"
              circle
              color="#14532D"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else>
        <div class="empty-state py-12 text-center">
          <v-icon size="64" color="#CBD5E1" class="mb-4">mdi-account-search-outline</v-icon>
          <h3 class="text-h6 font-weight-bold grey--text text--darken-2">No Rescuers Found</h3>
          <p class="text-body-2 grey--text text--darken-1">No rescuers match your selected filters.</p>
        </div>
      </v-flex>
    </v-layout>

      <v-dialog v-model="bulkBanDialog" max-width="500">
        <v-card>
          <v-card-title class="heading">Confirm Bulk Ban</v-card-title>
          <v-card-text>
            Are you sure you want to ban the {{ selectedItems.length }} selected rescuers?
            <v-text-field
              label="Reason (Optional)"
              v-model="bulkReason"
              outlined
              dense
              class="mt-3"
              color="#FF6907"
              hide-details
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              tile
              outlined
              color="#FF1313"
              light
              :ripple="false"
              depressed
              @click="bulkBanDialog = false"
              class="itemValue"
            >
              Cancel
            </v-btn>
            <v-btn
              tile
              :color="appColor"
              light
              :ripple="false"
              depressed
              @click="bulkBanUsers()"
              class="itemValue"
            >
              <span style="color: #fff">Confirm</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="bulkSuspendDialog" max-width="500">
        <v-card>
          <v-card-title class="heading">Confirm Bulk Suspend</v-card-title>
          <v-card-text>
            Are you sure you want to suspend the {{ selectedItems.length }} selected rescuers?
            <v-text-field
              label="Reason (Optional)"
              v-model="bulkReason"
              outlined
              dense
              class="mt-3"
              color="#FF6907"
              hide-details
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              tile
              outlined
              color="#FF1313"
              light
              :ripple="false"
              depressed
              @click="bulkSuspendDialog = false"
              class="itemValue"
            >
              Cancel
            </v-btn>
            <v-btn
              tile
              :color="appColor"
              light
              :ripple="false"
              depressed
              @click="bulkSuspendUsers()"
              class="itemValue"
            >
              <span style="color: #fff">Confirm</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Delete Rescuer</v-card-title>
        <v-card-text>
          Are you sure you want to delete this rescuer?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="deleteDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="deleteUser()"
            class="itemValue"
          >
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-dialog v-model="restrictDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>
          <div class="mb-4">Are you sure you want to ban this rescuer?</div>
          
          <div v-if="selectedRescuer" class="pa-3 rounded-lg mb-3" style="background-color: #fafafa; border: 1px solid #f0f0f0; border-radius: 8px;">
            <v-layout wrap align-center class="mb-2">
              <v-flex xs5 class="font-weight-medium text-left">Rescuer Name:</v-flex>
              <v-flex xs7 class="font-weight-bold text-left" style="color: #333;">
                {{ selectedRescuer.user ? selectedRescuer.user.name : '-' }}
              </v-flex>
            </v-layout>
            <v-layout wrap align-center>
              <v-flex xs5 class="font-weight-medium text-left">Average Rating:</v-flex>
              <v-flex xs7 class="text-left d-flex align-center">
                <v-rating
                  :value="Number(selectedRescuer.averageRating) || 0"
                  color="amber"
                  dense
                  half-increments
                  readonly
                  size="18"
                  class="d-inline-flex mr-2"
                ></v-rating>
                <span class="text-caption grey--text text--darken-1">({{ selectedRescuer.averageRating || 0 }} reviews)</span>
              </v-flex>
            </v-layout>
          </div>

          <!-- Optional reason input field -->
          <v-text-field
            label="Reason"
            v-model="reason"
            outlined
            dense
            class="mt-3"
            color="#FF6907"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="restrictDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="banUser()"
            class="itemValue"
          >
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="suspendDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Suspend Rescuer</v-card-title>
        <v-card-text>
          <div class="mb-4">Are you sure you want to suspend this rescuer?</div>
          
          <div v-if="selectedRescuer" class="pa-3 rounded-lg mb-3" style="background-color: #fafafa; border: 1px solid #f0f0f0; border-radius: 8px;">
            <v-layout wrap align-center class="mb-2">
              <v-flex xs5 class="font-weight-medium text-left">Rescuer Name:</v-flex>
              <v-flex xs7 class="font-weight-bold text-left" style="color: #333;">
                {{ selectedRescuer.user ? selectedRescuer.user.name : '-' }}
              </v-flex>
            </v-layout>
          </div>

          <v-text-field
            label="Reason"
            v-model="suspendReason"
            outlined
            dense
            class="mt-3"
            color="#FF6907"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="suspendDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="suspendUser()"
            class="itemValue"
          >
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
      <script>
import axios from "axios";
import debounce from 'lodash/debounce';

export default {
  data() {
    const pageKey = this.$route.name || 'defaultPage';
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      count: 20,
      keyword: "",
      pageKey,
      currentPage: parseInt(localStorage.getItem(`${pageKey}_currentPage`)) || 1,
      Pagelength: 0,
      userlist: [],
      restrictDialog: false,
      districts: [
        "All",
        "Palakkad",
        "Alappuzha",
        "Malappuram",
        "Kannur",
        "Wayanadu",
        "Kozhikode",
        "Thrissur",
        "Thiruvananthapuram",
        "Kottayam",
        "Idukki",
        "Ernakulam",
        "Kollam",
        "Pathanamthitta",
        "Kasaragod",
      ],
      deleteDialog: false,

      resourceCode: "",
      Name: "",
      Phone: "",

      banid : null,
      reason : "",
      selectedRescuer: null,
      suspendDialog: false,
      suspendid: null,
      suspendReason: "",

      selectedItems: [],
      selectAll: false,
      bulkBanDialog: false,
      bulkSuspendDialog: false,
      bulkReason: "",
    };
  },
  
  created() {
    this.debouncedGetData = debounce(() => {
      this.getData();
      this.currentPage = 1;
    }, 500);
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage(newVal) {
      localStorage.setItem(`${this.pageKey}_currentPage`, newVal);
      this.getData();
    },
    count() {
      this.getData();
    },
    keyword() {
      this.getData();
      this.currentPage = 1;
    },
    resourceCode() {
    this.debouncedGetData();
    },
    Name() {
      this.debouncedGetData();
    },
    Phone() {
      this.debouncedGetData();
    },
  },
  methods: {
    toggleSelectAll(val) {
      if (val) {
        this.selectedItems = this.userlist.map(item => item._id);
      } else {
        this.selectedItems = [];
      }
    },
    bulkBanUsers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rescuer/bulkbanrescuer",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          ids: this.selectedItems,
          isBanned: true,
          reason: this.bulkReason
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "Banned Successfully.";
            this.showSnackBar = true;
            this.appLoading = false;
            this.bulkBanDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.bulkBanDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    bulkSuspendUsers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rescuer/bulksuspendrescuer",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          ids: this.selectedItems,
          isSuspended: true,
          reason: this.bulkReason
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "Suspended Successfully.";
            this.showSnackBar = true;
            this.appLoading = false;
            this.bulkSuspendDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.bulkSuspendDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    openviewdetails(item) {
      this.$router.push({
        path: "/rescuerslistview",
        query: {
          id: item._id,
        },
      });
    },
    getExcel() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/rescuer/getlist/download/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        responseType: "blob",
        params: {
          keyword: this.keyword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "RescuerList.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    rejectDialog(item) {
      this.deleteDialog = true;
      this.deleteid = item;
    },
    banDialog(item) {
      this.restrictDialog = true;
      this.banid = item._id;
      this.selectedRescuer = item;
      this.reason = "";
    },
    openSuspendDialog(item) {
      this.suspendDialog = true;
      this.suspendid = item._id;
      this.selectedRescuer = item;
      this.suspendReason = "";
    },
    openeditdetails(item) {
      this.$router.push({
        path: "/newrescuerslistedit",
        query: {
          id: item.user._id,
        },
      });
    },
    deleteUser() {
      this.appLoading = true;
      axios({
        method: "DELETE",
        url: "/user/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.deleteid,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Deleted Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.deleteDialog = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.deleteDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    banUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rescuer/banrescuer",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.banid,
          isBanned: true,
          reason: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Banned Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.restrictDialog = false;
              this.getData();
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.restrictDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    suspendUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rescuer/suspendrescuer",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.suspendid,
          isSuspended: true,
          reason: this.suspendReason,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Suspended Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.suspendDialog = false;
              this.getData();
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.suspendDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/rescuer/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          keyword: this.keyword,
          searchCode: this.resourceCode,
          searchName: this.Name,
          searchPhone: this.Phone,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.userlist = response.data.data;
              this.Pagelength = response.data.pages;
              this.selectedItems = [];
              this.selectAll = false;
              this.bulkReason = "";
              // this.msg = response.data.msg;
              // this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.userlist = [];
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    handlesubmit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/snake/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.commonname,
          scientificName: this.scientificname,
          states: this.state,
          rname: this.reginonalname,
          distribution: this.distribution,
          characteristics: this.scalation,
          description: this.description,
          venomType: this.venomtype,
          family: this.family,
          occurence: this.occurence,
          wlpa: this.wlpa,
          iucn: this.iucn,
          shortdes: this.shortdescription,
          othernames: this.othername,
          genus: this.genus,
          experts: this.experts,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
              this.commonname = "";
              this.scientificname = "";
              this.state = "";
              this.reginonalname = "";
              this.distribution = "";
              this.scalation = "";
              this.description = "";
              this.venomtype = "";
              this.family = "";
              this.occurence = "";
              this.wlpa = "";
              this.iucn = "";
              this.shortdescription = "";
              this.othername = "";
              this.genus = "";
              this.experts = "";
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
  },
};
</script>
<style scoped>
/* ── Filter Card ── */
.filter-card {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  padding: 12px 6px;
}
.filter-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748B;
  margin-bottom: 6px;
  padding-left: 2px;
}

/* ── Custom Inputs ── */
.custom-select ::v-deep .v-input__control > .v-input__slot,
.custom-input ::v-deep .v-input__control > .v-input__slot {
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}
.custom-select ::v-deep .v-input__control > .v-input__slot:hover,
.custom-input ::v-deep .v-input__control > .v-input__slot:hover {
  border-color: #CBD5E1 !important;
  background: #F1F5F9 !important;
}

/* ── Export Button ── */
.export-btn {
  background-color: #10B981 !important;
  color: #FFFFFF !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  border-radius: 8px !important;
  height: 40px !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.18) !important;
  transition: all 0.2s ease !important;
}
.export-btn:hover {
  background-color: #059669 !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.25) !important;
}

/* ── Table Card ── */
.custom-table-card {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.03) !important;
  background: #FFFFFF;
}

/* Table layout styling */
.custom-table-card ::v-deep table {
  border-collapse: collapse;
  width: 100%;
}
.custom-table-card ::v-deep thead {
  background-color: #F8FAFC;
}
.custom-table-card ::v-deep th {
  height: 48px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em !important;
  color: #64748B !important;
  text-transform: uppercase !important;
  border-bottom: 2px solid #F1F5F9 !important;
  padding: 0 16px !important;
}
.custom-table-card ::v-deep td {
  height: 58px !important;
  font-size: 13px !important;
  color: #334155 !important;
  border-bottom: 1px solid #F1F5F9 !important;
  padding: 0 16px !important;
}

/* ── Clickable Rows ── */
.clickable-row {
  cursor: pointer;
  transition: background-color 0.18s ease;
}
.clickable-row:hover {
  background-color: #F3F7F4 !important;
}
.clickable-row:active {
  background-color: #EBF2ED !important;
}
.text-muted {
  color: #94A3B8;
}

/* ── Action buttons ── */
.action-group {
  gap: 8px;
}
.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.action-btn:hover {
  transform: scale(1.08);
}
.action-btn--edit {
  background: rgba(20, 83, 45, 0.06);
  color: #16A34A !important;
}
.action-btn--edit:hover {
  background: rgba(20, 83, 45, 0.12);
  color: #14532D !important;
}
.action-btn--suspend {
  background: rgba(217, 119, 6, 0.06);
  color: #D97706 !important;
}
.action-btn--suspend:hover {
  background: rgba(217, 119, 6, 0.12);
  color: #B45309 !important;
}
.action-btn--ban {
  background: rgba(220, 38, 38, 0.06);
  color: #DC2626 !important;
}
.action-btn--ban:hover {
  background: rgba(220, 38, 38, 0.12);
  color: #991B1B !important;
}
.action-btn--delete {
  background: rgba(220, 38, 38, 0.06);
  color: #DC2626 !important;
}
.action-btn--delete:hover {
  background: rgba(220, 38, 38, 0.12);
  color: #991B1B !important;
}

/* ── Empty State ── */
.empty-state {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px dashed #E2E8F0;
}
</style>